import { render, staticRenderFns } from "./VerticalFormLayout.vue?vue&type=template&id=6d5d25c5"
import script from "./VerticalFormLayout.vue?vue&type=script&lang=js"
export * from "./VerticalFormLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports